// Generated from ./src/providers/syntax/lexer/FPlusLexer.g4 by ANTLR 4.13.2
// noinspection ES6UnusedImports,JSUnusedGlobalSymbols,JSUnusedLocalSymbols
import {
  ATN,
  ATNDeserializer,
  CharStream,
  type DecisionState,
  DFA,
  Lexer,
  LexerATNSimulator,
  PredictionContextCache,
  RuleContext,
  Token,
} from 'antlr4'
export default class FPlusLexer extends Lexer {
  public static readonly BLOCK_EXPRESSION_ERROR_LABEL = 1
  public static readonly BLOCK_END = 2
  public static readonly WS = 3
  public static readonly COMMENT = 4
  public static readonly NL = 5
  public static readonly DOT = 6
  public static readonly COMMA = 7
  public static readonly LPAREN = 8
  public static readonly RPAREN = 9
  public static readonly LSQUARE = 10
  public static readonly RSQUARE = 11
  public static readonly LCURL = 12
  public static readonly RCURL = 13
  public static readonly MULT = 14
  public static readonly POW = 15
  public static readonly DIV = 16
  public static readonly ADD = 17
  public static readonly SUB = 18
  public static readonly XOR = 19
  public static readonly INCR = 20
  public static readonly DECR = 21
  public static readonly CONJ = 22
  public static readonly NOT = 23
  public static readonly MONEYDECIMAL = 24
  public static readonly MONEY = 25
  public static readonly DISJ = 26
  public static readonly PERCENT = 27
  public static readonly EXCL = 28
  public static readonly COLON = 29
  public static readonly SEMICOLON = 30
  public static readonly ASSIGNMENT = 31
  public static readonly ARROW = 32
  public static readonly DOUBLE_ARROW = 33
  public static readonly RANGE = 34
  public static readonly COLON_COLON = 35
  public static readonly DOUBLE_SEMICOLON = 36
  public static readonly QUEST = 37
  public static readonly QUEST_COLON = 38
  public static readonly LANGLE = 39
  public static readonly RANGLE = 40
  public static readonly LE = 41
  public static readonly GE = 42
  public static readonly EXCL_EQ = 43
  public static readonly AT = 44
  public static readonly UNDERSCORE = 45
  public static readonly POUND = 46
  public static readonly MAP = 47
  public static readonly FUN = 48
  public static readonly LET = 49
  public static readonly IMPORT = 50
  public static readonly ASSERT = 51
  public static readonly VAR = 52
  public static readonly WHERE = 53
  public static readonly IF = 54
  public static readonly THEN = 55
  public static readonly ELSE = 56
  public static readonly WHEN = 57
  public static readonly AS = 58
  public static readonly IS = 59
  public static readonly IN = 60
  public static readonly OUT = 61
  public static readonly USE = 62
  public static readonly NOT_IS = 63
  public static readonly NOT_IN = 64
  public static readonly IS_IN = 65
  public static readonly DecimalLiteral = 66
  public static readonly IntegerLiteral = 67
  public static readonly MoneyDecimalLiteral = 68
  public static readonly MoneyLiteral = 69
  public static readonly BooleanLiteral = 70
  public static readonly UndefinedLiteral = 71
  public static readonly DateLiteral = 72
  public static readonly Identifier = 73
  public static readonly IdentifierOrSoftKey = 74
  public static readonly SINGLE_QUOTE_OPEN = 75
  public static readonly QUOTE_OPEN = 76
  public static readonly TRIPLE_QUOTE_OPEN = 77
  public static readonly UNICODE_CLASS_LL = 78
  public static readonly UNICODE_CLASS_LM = 79
  public static readonly UNICODE_CLASS_LO = 80
  public static readonly UNICODE_CLASS_LT = 81
  public static readonly UNICODE_CLASS_LU = 82
  public static readonly UNICODE_CLASS_ND = 83
  public static readonly UNICODE_CLASS_NL = 84
  public static readonly QUOTE_CLOSE = 85
  public static readonly LineStrText = 86
  public static readonly LineStrEscapedChar = 87
  public static readonly LineStrExprStart = 88
  public static readonly SINGLE_QUOTE_CLOSE = 89
  public static readonly SingleLineStrText = 90
  public static readonly SingleLineStrEscapedChar = 91
  public static readonly SingleLineStrExprStart = 92
  public static readonly TRIPLE_QUOTE_CLOSE = 93
  public static readonly MultiLineStringQuote = 94
  public static readonly MultiLineStrText = 95
  public static readonly MultiLineStrEscapedChar = 96
  public static readonly MultiLineStrExprStart = 97
  public static readonly ErrorCharacter = 98
  public static readonly EOF = Token.EOF
  public static readonly LineString = 1
  public static readonly SingleQuoteLineString = 2
  public static readonly MultiLineString = 3

  public static readonly channelNames: string[] = [
    'DEFAULT_TOKEN_CHANNEL',
    'HIDDEN',
  ]
  public static readonly literalNames: (string | null)[] = [
    null,
    null,
    "'\\u00A7/BLOCK'",
    null,
    null,
    null,
    "'.'",
    "','",
    "'('",
    "')'",
    "'['",
    "']'",
    "'{'",
    "'}'",
    "'*'",
    "'^'",
    "'/'",
    "'+'",
    "'-'",
    "'xor'",
    "'++'",
    "'--'",
    "'and'",
    "'not'",
    null,
    null,
    "'or'",
    "'%'",
    "'!'",
    "':'",
    "';'",
    "'='",
    "'->'",
    "'=>'",
    "'..'",
    "'::'",
    "';;'",
    "'?'",
    "'?:'",
    "'<'",
    "'>'",
    "'<='",
    "'>='",
    "'!='",
    "'@'",
    "'_'",
    "'#'",
    "'map'",
    "'fun'",
    "'let'",
    "'import'",
    "'assert'",
    "'var'",
    "'where'",
    "'if'",
    "'then'",
    "'else'",
    "'when'",
    "'as'",
    "'is'",
    "'in'",
    "'out'",
    "'use'",
    "'isnot'",
    "'notin'",
    "'isin'",
    null,
    null,
    null,
    null,
    null,
    "'undefined'",
    null,
    null,
    null,
    null,
    null,
    '\'"""\'',
  ]
  public static readonly symbolicNames: (string | null)[] = [
    null,
    'BLOCK_EXPRESSION_ERROR_LABEL',
    'BLOCK_END',
    'WS',
    'COMMENT',
    'NL',
    'DOT',
    'COMMA',
    'LPAREN',
    'RPAREN',
    'LSQUARE',
    'RSQUARE',
    'LCURL',
    'RCURL',
    'MULT',
    'POW',
    'DIV',
    'ADD',
    'SUB',
    'XOR',
    'INCR',
    'DECR',
    'CONJ',
    'NOT',
    'MONEYDECIMAL',
    'MONEY',
    'DISJ',
    'PERCENT',
    'EXCL',
    'COLON',
    'SEMICOLON',
    'ASSIGNMENT',
    'ARROW',
    'DOUBLE_ARROW',
    'RANGE',
    'COLON_COLON',
    'DOUBLE_SEMICOLON',
    'QUEST',
    'QUEST_COLON',
    'LANGLE',
    'RANGLE',
    'LE',
    'GE',
    'EXCL_EQ',
    'AT',
    'UNDERSCORE',
    'POUND',
    'MAP',
    'FUN',
    'LET',
    'IMPORT',
    'ASSERT',
    'VAR',
    'WHERE',
    'IF',
    'THEN',
    'ELSE',
    'WHEN',
    'AS',
    'IS',
    'IN',
    'OUT',
    'USE',
    'NOT_IS',
    'NOT_IN',
    'IS_IN',
    'DecimalLiteral',
    'IntegerLiteral',
    'MoneyDecimalLiteral',
    'MoneyLiteral',
    'BooleanLiteral',
    'UndefinedLiteral',
    'DateLiteral',
    'Identifier',
    'IdentifierOrSoftKey',
    'SINGLE_QUOTE_OPEN',
    'QUOTE_OPEN',
    'TRIPLE_QUOTE_OPEN',
    'UNICODE_CLASS_LL',
    'UNICODE_CLASS_LM',
    'UNICODE_CLASS_LO',
    'UNICODE_CLASS_LT',
    'UNICODE_CLASS_LU',
    'UNICODE_CLASS_ND',
    'UNICODE_CLASS_NL',
    'QUOTE_CLOSE',
    'LineStrText',
    'LineStrEscapedChar',
    'LineStrExprStart',
    'SINGLE_QUOTE_CLOSE',
    'SingleLineStrText',
    'SingleLineStrEscapedChar',
    'SingleLineStrExprStart',
    'TRIPLE_QUOTE_CLOSE',
    'MultiLineStringQuote',
    'MultiLineStrText',
    'MultiLineStrEscapedChar',
    'MultiLineStrExprStart',
    'ErrorCharacter',
  ]
  public static readonly modeNames: string[] = [
    'DEFAULT_MODE',
    'LineString',
    'SingleQuoteLineString',
    'MultiLineString',
  ]

  public static readonly ruleNames: string[] = [
    'BLOCK',
    'VARIABLE',
    'BLOCKID',
    'BLOCK_EXPRESSION_ERROR_LABEL',
    'BLOCK_END',
    'WS',
    'COMMENT',
    'NL',
    'DOT',
    'COMMA',
    'LPAREN',
    'RPAREN',
    'LSQUARE',
    'RSQUARE',
    'LCURL',
    'RCURL',
    'MULT',
    'POW',
    'DIV',
    'ADD',
    'SUB',
    'XOR',
    'INCR',
    'DECR',
    'CONJ',
    'NOT',
    'MONEYDECIMAL',
    'MONEY',
    'DISJ',
    'PERCENT',
    'EXCL',
    'COLON',
    'SEMICOLON',
    'ASSIGNMENT',
    'ARROW',
    'DOUBLE_ARROW',
    'RANGE',
    'COLON_COLON',
    'DOUBLE_SEMICOLON',
    'QUEST',
    'QUEST_COLON',
    'LANGLE',
    'RANGLE',
    'LE',
    'GE',
    'EXCL_EQ',
    'AT',
    'UNDERSCORE',
    'POUND',
    'MAP',
    'FUN',
    'LET',
    'IMPORT',
    'ASSERT',
    'VAR',
    'WHERE',
    'IF',
    'THEN',
    'ELSE',
    'WHEN',
    'AS',
    'IS',
    'IN',
    'OUT',
    'USE',
    'NOT_IS',
    'NOT_IN',
    'IS_IN',
    'DecDigit',
    'DecDigitNoZero',
    'DecDigitOrSeparator',
    'Year',
    'Month',
    'Day',
    'DecDigits',
    'DecimalLiteral',
    'IntegerLiteral',
    'MoneyDecimalLiteral',
    'MoneyLiteral',
    'BooleanLiteral',
    'UndefinedLiteral',
    'DateLiteral',
    'UnicodeDigit',
    'Identifier',
    'IdentifierOrSoftKey',
    'SingleLinEscapedIdentifier',
    'MultiLineEscapedIdentifier',
    'Letter',
    'SINGLE_QUOTE_OPEN',
    'QUOTE_OPEN',
    'TRIPLE_QUOTE_OPEN',
    'UNICODE_CLASS_LL',
    'UNICODE_CLASS_LM',
    'UNICODE_CLASS_LO',
    'UNICODE_CLASS_LT',
    'UNICODE_CLASS_LU',
    'UNICODE_CLASS_ND',
    'UNICODE_CLASS_NL',
    'QUOTE_CLOSE',
    'LineStrText',
    'LineStrEscapedChar',
    'LineStrExprStart',
    'SINGLE_QUOTE_CLOSE',
    'SingleLineStrText',
    'SingleLineStrEscapedChar',
    'SingleLineStrExprStart',
    'TRIPLE_QUOTE_CLOSE',
    'MultiLineStringQuote',
    'MultiLineStrText',
    'MultiLineStrEscapedChar',
    'MultiLineStrExprStart',
    'ErrorCharacter',
  ]

  constructor(input: CharStream) {
    super(input)
    this._interp = new LexerATNSimulator(
      this,
      FPlusLexer._ATN,
      FPlusLexer.DecisionsToDFA,
      new PredictionContextCache(),
    )
  }

  public get grammarFileName(): string {
    return 'FPlusLexer.g4'
  }

  public get literalNames(): (string | null)[] {
    return FPlusLexer.literalNames
  }
  public get symbolicNames(): (string | null)[] {
    return FPlusLexer.symbolicNames
  }
  public get ruleNames(): string[] {
    return FPlusLexer.ruleNames
  }

  public get serializedATN(): number[] {
    return FPlusLexer._serializedATN
  }

  public get channelNames(): string[] {
    return FPlusLexer.channelNames
  }

  public get modeNames(): string[] {
    return FPlusLexer.modeNames
  }

  // @Override
  public action(
    localctx: RuleContext,
    ruleIndex: number,
    actionIndex: number,
  ): void {
    switch (ruleIndex) {
      case 15:
        this.RCURL_action(localctx, actionIndex)
        break
    }
  }
  private RCURL_action(_localctx: RuleContext, actionIndex: number): void {
    switch (actionIndex) {
      case 0:
        if (!this.getModeStack.length) {
          this.popMode()
        }

        break
    }
  }

  public static readonly _serializedATN: number[] = [
    4, 0, 98, 732, 6, -1, 6, -1, 6, -1, 6, -1, 2, 0, 7, 0, 2, 1, 7, 1, 2, 2, 7,
    2, 2, 3, 7, 3, 2, 4, 7, 4, 2, 5, 7, 5, 2, 6, 7, 6, 2, 7, 7, 7, 2, 8, 7, 8,
    2, 9, 7, 9, 2, 10, 7, 10, 2, 11, 7, 11, 2, 12, 7, 12, 2, 13, 7, 13, 2, 14,
    7, 14, 2, 15, 7, 15, 2, 16, 7, 16, 2, 17, 7, 17, 2, 18, 7, 18, 2, 19, 7, 19,
    2, 20, 7, 20, 2, 21, 7, 21, 2, 22, 7, 22, 2, 23, 7, 23, 2, 24, 7, 24, 2, 25,
    7, 25, 2, 26, 7, 26, 2, 27, 7, 27, 2, 28, 7, 28, 2, 29, 7, 29, 2, 30, 7, 30,
    2, 31, 7, 31, 2, 32, 7, 32, 2, 33, 7, 33, 2, 34, 7, 34, 2, 35, 7, 35, 2, 36,
    7, 36, 2, 37, 7, 37, 2, 38, 7, 38, 2, 39, 7, 39, 2, 40, 7, 40, 2, 41, 7, 41,
    2, 42, 7, 42, 2, 43, 7, 43, 2, 44, 7, 44, 2, 45, 7, 45, 2, 46, 7, 46, 2, 47,
    7, 47, 2, 48, 7, 48, 2, 49, 7, 49, 2, 50, 7, 50, 2, 51, 7, 51, 2, 52, 7, 52,
    2, 53, 7, 53, 2, 54, 7, 54, 2, 55, 7, 55, 2, 56, 7, 56, 2, 57, 7, 57, 2, 58,
    7, 58, 2, 59, 7, 59, 2, 60, 7, 60, 2, 61, 7, 61, 2, 62, 7, 62, 2, 63, 7, 63,
    2, 64, 7, 64, 2, 65, 7, 65, 2, 66, 7, 66, 2, 67, 7, 67, 2, 68, 7, 68, 2, 69,
    7, 69, 2, 70, 7, 70, 2, 71, 7, 71, 2, 72, 7, 72, 2, 73, 7, 73, 2, 74, 7, 74,
    2, 75, 7, 75, 2, 76, 7, 76, 2, 77, 7, 77, 2, 78, 7, 78, 2, 79, 7, 79, 2, 80,
    7, 80, 2, 81, 7, 81, 2, 82, 7, 82, 2, 83, 7, 83, 2, 84, 7, 84, 2, 85, 7, 85,
    2, 86, 7, 86, 2, 87, 7, 87, 2, 88, 7, 88, 2, 89, 7, 89, 2, 90, 7, 90, 2, 91,
    7, 91, 2, 92, 7, 92, 2, 93, 7, 93, 2, 94, 7, 94, 2, 95, 7, 95, 2, 96, 7, 96,
    2, 97, 7, 97, 2, 98, 7, 98, 2, 99, 7, 99, 2, 100, 7, 100, 2, 101, 7, 101, 2,
    102, 7, 102, 2, 103, 7, 103, 2, 104, 7, 104, 2, 105, 7, 105, 2, 106, 7, 106,
    2, 107, 7, 107, 2, 108, 7, 108, 2, 109, 7, 109, 2, 110, 7, 110, 2, 111, 7,
    111, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 2, 5, 2, 248, 8, 2, 10, 2, 12, 2,
    251, 9, 2, 1, 2, 1, 2, 1, 3, 1, 3, 3, 3, 257, 8, 3, 1, 3, 1, 3, 1, 3, 1, 3,
    1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 1, 5, 1, 5, 1,
    5, 1, 5, 1, 6, 1, 6, 1, 6, 1, 6, 5, 6, 281, 8, 6, 10, 6, 12, 6, 284, 9, 6,
    1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 7, 1, 7, 1, 7, 1, 7, 1, 8, 1, 8, 1, 9, 1,
    9, 1, 10, 1, 10, 1, 11, 1, 11, 1, 12, 1, 12, 1, 13, 1, 13, 1, 14, 1, 14, 1,
    14, 1, 14, 1, 15, 1, 15, 1, 15, 1, 16, 1, 16, 1, 17, 1, 17, 1, 18, 1, 18, 1,
    19, 1, 19, 1, 20, 1, 20, 1, 21, 1, 21, 1, 21, 1, 21, 1, 22, 1, 22, 1, 22, 1,
    23, 1, 23, 1, 23, 1, 24, 1, 24, 1, 24, 1, 24, 1, 25, 1, 25, 1, 25, 1, 25, 1,
    26, 1, 26, 1, 26, 1, 26, 1, 26, 1, 26, 1, 26, 1, 26, 3, 26, 350, 8, 26, 1,
    27, 1, 27, 1, 28, 1, 28, 1, 28, 1, 29, 1, 29, 1, 30, 1, 30, 1, 31, 1, 31, 1,
    32, 1, 32, 1, 33, 1, 33, 1, 34, 1, 34, 1, 34, 1, 35, 1, 35, 1, 35, 1, 36, 1,
    36, 1, 36, 1, 37, 1, 37, 1, 37, 1, 38, 1, 38, 1, 38, 1, 39, 1, 39, 1, 40, 1,
    40, 1, 40, 1, 41, 1, 41, 1, 42, 1, 42, 1, 43, 1, 43, 1, 43, 1, 44, 1, 44, 1,
    44, 1, 45, 1, 45, 1, 45, 1, 46, 1, 46, 1, 47, 1, 47, 1, 48, 1, 48, 1, 49, 1,
    49, 1, 49, 1, 49, 1, 50, 1, 50, 1, 50, 1, 50, 1, 51, 1, 51, 1, 51, 1, 51, 1,
    52, 1, 52, 1, 52, 1, 52, 1, 52, 1, 52, 1, 52, 1, 53, 1, 53, 1, 53, 1, 53, 1,
    53, 1, 53, 1, 53, 1, 54, 1, 54, 1, 54, 1, 54, 1, 55, 1, 55, 1, 55, 1, 55, 1,
    55, 1, 55, 1, 56, 1, 56, 1, 56, 1, 57, 1, 57, 1, 57, 1, 57, 1, 57, 1, 58, 1,
    58, 1, 58, 1, 58, 1, 58, 1, 59, 1, 59, 1, 59, 1, 59, 1, 59, 1, 60, 1, 60, 1,
    60, 1, 61, 1, 61, 1, 61, 1, 62, 1, 62, 1, 62, 1, 63, 1, 63, 1, 63, 1, 63, 1,
    64, 1, 64, 1, 64, 1, 64, 1, 65, 1, 65, 1, 65, 1, 65, 1, 65, 1, 65, 1, 66, 1,
    66, 1, 66, 1, 66, 1, 66, 1, 66, 1, 67, 1, 67, 1, 67, 1, 67, 1, 67, 1, 68, 1,
    68, 1, 69, 1, 69, 1, 70, 1, 70, 3, 70, 500, 8, 70, 1, 71, 1, 71, 1, 71, 1,
    71, 1, 71, 1, 72, 3, 72, 508, 8, 72, 1, 72, 1, 72, 1, 73, 3, 73, 513, 8, 73,
    1, 73, 1, 73, 1, 74, 1, 74, 5, 74, 519, 8, 74, 10, 74, 12, 74, 522, 9, 74,
    1, 74, 1, 74, 1, 74, 3, 74, 527, 8, 74, 1, 75, 3, 75, 530, 8, 75, 1, 75, 1,
    75, 1, 75, 1, 76, 1, 76, 5, 76, 537, 8, 76, 10, 76, 12, 76, 540, 9, 76, 1,
    76, 1, 76, 1, 76, 3, 76, 545, 8, 76, 1, 77, 1, 77, 3, 77, 549, 8, 77, 1, 77,
    1, 77, 1, 78, 3, 78, 554, 8, 78, 1, 78, 1, 78, 3, 78, 558, 8, 78, 1, 78, 1,
    78, 3, 78, 562, 8, 78, 1, 78, 1, 78, 1, 79, 1, 79, 1, 79, 1, 79, 1, 79, 1,
    79, 1, 79, 1, 79, 1, 79, 3, 79, 575, 8, 79, 1, 80, 1, 80, 1, 80, 1, 80, 1,
    80, 1, 80, 1, 80, 1, 80, 1, 80, 1, 80, 1, 81, 1, 81, 1, 81, 1, 81, 1, 81, 1,
    81, 1, 81, 1, 82, 1, 82, 1, 83, 1, 83, 3, 83, 598, 8, 83, 1, 83, 1, 83, 1,
    83, 5, 83, 603, 8, 83, 10, 83, 12, 83, 606, 9, 83, 1, 83, 1, 83, 4, 83, 610,
    8, 83, 11, 83, 12, 83, 611, 1, 83, 3, 83, 615, 8, 83, 1, 84, 1, 84, 1, 84,
    3, 84, 620, 8, 84, 1, 85, 1, 85, 1, 85, 1, 86, 1, 86, 1, 86, 1, 87, 1, 87,
    1, 87, 1, 87, 1, 87, 1, 87, 3, 87, 634, 8, 87, 1, 88, 1, 88, 1, 88, 1, 88,
    1, 89, 1, 89, 1, 89, 1, 89, 1, 90, 1, 90, 1, 90, 1, 90, 1, 90, 1, 90, 1, 91,
    1, 91, 1, 92, 1, 92, 1, 93, 1, 93, 1, 94, 1, 94, 1, 95, 1, 95, 1, 96, 1, 96,
    1, 97, 1, 97, 1, 98, 1, 98, 1, 98, 1, 98, 1, 99, 4, 99, 669, 8, 99, 11, 99,
    12, 99, 670, 1, 99, 3, 99, 674, 8, 99, 1, 100, 1, 100, 1, 101, 1, 101, 1,
    101, 1, 101, 1, 101, 1, 102, 1, 102, 1, 102, 1, 102, 1, 103, 4, 103, 688, 8,
    103, 11, 103, 12, 103, 689, 1, 103, 3, 103, 693, 8, 103, 1, 104, 1, 104, 1,
    105, 1, 105, 1, 105, 1, 105, 1, 105, 1, 106, 3, 106, 703, 8, 106, 1, 106, 1,
    106, 1, 106, 1, 106, 1, 106, 1, 106, 1, 107, 4, 107, 712, 8, 107, 11, 107,
    12, 107, 713, 1, 108, 4, 108, 717, 8, 108, 11, 108, 12, 108, 718, 1, 108, 3,
    108, 722, 8, 108, 1, 109, 1, 109, 1, 110, 1, 110, 1, 110, 1, 110, 1, 110, 1,
    111, 1, 111, 2, 249, 282, 0, 112, 4, 0, 6, 0, 8, 0, 10, 1, 12, 2, 14, 3, 16,
    4, 18, 5, 20, 6, 22, 7, 24, 8, 26, 9, 28, 10, 30, 11, 32, 12, 34, 13, 36,
    14, 38, 15, 40, 16, 42, 17, 44, 18, 46, 19, 48, 20, 50, 21, 52, 22, 54, 23,
    56, 24, 58, 25, 60, 26, 62, 27, 64, 28, 66, 29, 68, 30, 70, 31, 72, 32, 74,
    33, 76, 34, 78, 35, 80, 36, 82, 37, 84, 38, 86, 39, 88, 40, 90, 41, 92, 42,
    94, 43, 96, 44, 98, 45, 100, 46, 102, 47, 104, 48, 106, 49, 108, 50, 110,
    51, 112, 52, 114, 53, 116, 54, 118, 55, 120, 56, 122, 57, 124, 58, 126, 59,
    128, 60, 130, 61, 132, 62, 134, 63, 136, 64, 138, 65, 140, 0, 142, 0, 144,
    0, 146, 0, 148, 0, 150, 0, 152, 0, 154, 66, 156, 67, 158, 68, 160, 69, 162,
    70, 164, 71, 166, 72, 168, 0, 170, 73, 172, 74, 174, 0, 176, 0, 178, 0, 180,
    75, 182, 76, 184, 77, 186, 78, 188, 79, 190, 80, 192, 81, 194, 82, 196, 83,
    198, 84, 200, 85, 202, 86, 204, 87, 206, 88, 208, 89, 210, 90, 212, 91, 214,
    92, 216, 93, 218, 94, 220, 95, 222, 96, 224, 97, 226, 98, 4, 0, 1, 2, 3, 17,
    1, 0, 164, 164, 3, 0, 9, 9, 12, 12, 32, 32, 2, 0, 10, 10, 13, 13, 3, 0, 36,
    36, 163, 164, 8364, 8364, 1, 0, 39, 39, 3, 0, 10, 10, 13, 13, 96, 96, 8, 0,
    34, 34, 36, 36, 39, 39, 92, 92, 98, 98, 110, 110, 114, 114, 116, 116, 6, 0,
    36, 36, 92, 92, 98, 98, 110, 110, 114, 114, 116, 116, 583, 0, 97, 122, 164,
    164, 181, 181, 223, 246, 248, 255, 257, 257, 259, 259, 261, 261, 263, 263,
    265, 265, 267, 267, 269, 269, 271, 271, 273, 273, 275, 275, 277, 277, 279,
    279, 281, 281, 283, 283, 285, 285, 287, 287, 289, 289, 291, 291, 293, 293,
    295, 295, 297, 297, 299, 299, 301, 301, 303, 303, 305, 305, 307, 307, 309,
    309, 311, 312, 314, 314, 316, 316, 318, 318, 320, 320, 322, 322, 324, 324,
    326, 326, 328, 329, 331, 331, 333, 333, 335, 335, 337, 337, 339, 339, 341,
    341, 343, 343, 345, 345, 347, 347, 349, 349, 351, 351, 353, 353, 355, 355,
    357, 357, 359, 359, 361, 361, 363, 363, 365, 365, 367, 367, 369, 369, 371,
    371, 373, 373, 375, 375, 378, 378, 380, 380, 382, 384, 387, 387, 389, 389,
    392, 392, 396, 397, 402, 402, 405, 405, 409, 411, 414, 414, 417, 417, 419,
    419, 421, 421, 424, 424, 426, 427, 429, 429, 432, 432, 436, 436, 438, 438,
    441, 442, 445, 447, 454, 454, 457, 457, 460, 460, 462, 462, 464, 464, 466,
    466, 468, 468, 470, 470, 472, 472, 474, 474, 476, 477, 479, 479, 481, 481,
    483, 483, 485, 485, 487, 487, 489, 489, 491, 491, 493, 493, 495, 496, 499,
    499, 501, 501, 505, 505, 507, 507, 509, 509, 511, 511, 513, 513, 515, 515,
    517, 517, 519, 519, 521, 521, 523, 523, 525, 525, 527, 527, 529, 529, 531,
    531, 533, 533, 535, 535, 537, 537, 539, 539, 541, 541, 543, 543, 545, 545,
    547, 547, 549, 549, 551, 551, 553, 553, 555, 555, 557, 557, 559, 559, 561,
    561, 563, 569, 572, 572, 575, 576, 578, 578, 583, 583, 585, 585, 587, 587,
    589, 589, 591, 659, 661, 687, 881, 881, 883, 883, 887, 887, 891, 893, 912,
    912, 940, 974, 976, 977, 981, 983, 985, 985, 987, 987, 989, 989, 991, 991,
    993, 993, 995, 995, 997, 997, 999, 999, 1001, 1001, 1003, 1003, 1005, 1005,
    1007, 1011, 1013, 1013, 1016, 1016, 1019, 1020, 1072, 1119, 1121, 1121,
    1123, 1123, 1125, 1125, 1127, 1127, 1129, 1129, 1131, 1131, 1133, 1133,
    1135, 1135, 1137, 1137, 1139, 1139, 1141, 1141, 1143, 1143, 1145, 1145,
    1147, 1147, 1149, 1149, 1151, 1151, 1153, 1153, 1163, 1163, 1165, 1165,
    1167, 1167, 1169, 1169, 1171, 1171, 1173, 1173, 1175, 1175, 1177, 1177,
    1179, 1179, 1181, 1181, 1183, 1183, 1185, 1185, 1187, 1187, 1189, 1189,
    1191, 1191, 1193, 1193, 1195, 1195, 1197, 1197, 1199, 1199, 1201, 1201,
    1203, 1203, 1205, 1205, 1207, 1207, 1209, 1209, 1211, 1211, 1213, 1213,
    1215, 1215, 1218, 1218, 1220, 1220, 1222, 1222, 1224, 1224, 1226, 1226,
    1228, 1228, 1230, 1231, 1233, 1233, 1235, 1235, 1237, 1237, 1239, 1239,
    1241, 1241, 1243, 1243, 1245, 1245, 1247, 1247, 1249, 1249, 1251, 1251,
    1253, 1253, 1255, 1255, 1257, 1257, 1259, 1259, 1261, 1261, 1263, 1263,
    1265, 1265, 1267, 1267, 1269, 1269, 1271, 1271, 1273, 1273, 1275, 1275,
    1277, 1277, 1279, 1279, 1281, 1281, 1283, 1283, 1285, 1285, 1287, 1287,
    1289, 1289, 1291, 1291, 1293, 1293, 1295, 1295, 1297, 1297, 1299, 1299,
    1301, 1301, 1303, 1303, 1305, 1305, 1307, 1307, 1309, 1309, 1311, 1311,
    1313, 1313, 1315, 1315, 1317, 1317, 1319, 1319, 1377, 1415, 7424, 7467,
    7531, 7543, 7545, 7578, 7681, 7681, 7683, 7683, 7685, 7685, 7687, 7687,
    7689, 7689, 7691, 7691, 7693, 7693, 7695, 7695, 7697, 7697, 7699, 7699,
    7701, 7701, 7703, 7703, 7705, 7705, 7707, 7707, 7709, 7709, 7711, 7711,
    7713, 7713, 7715, 7715, 7717, 7717, 7719, 7719, 7721, 7721, 7723, 7723,
    7725, 7725, 7727, 7727, 7729, 7729, 7731, 7731, 7733, 7733, 7735, 7735,
    7737, 7737, 7739, 7739, 7741, 7741, 7743, 7743, 7745, 7745, 7747, 7747,
    7749, 7749, 7751, 7751, 7753, 7753, 7755, 7755, 7757, 7757, 7759, 7759,
    7761, 7761, 7763, 7763, 7765, 7765, 7767, 7767, 7769, 7769, 7771, 7771,
    7773, 7773, 7775, 7775, 7777, 7777, 7779, 7779, 7781, 7781, 7783, 7783,
    7785, 7785, 7787, 7787, 7789, 7789, 7791, 7791, 7793, 7793, 7795, 7795,
    7797, 7797, 7799, 7799, 7801, 7801, 7803, 7803, 7805, 7805, 7807, 7807,
    7809, 7809, 7811, 7811, 7813, 7813, 7815, 7815, 7817, 7817, 7819, 7819,
    7821, 7821, 7823, 7823, 7825, 7825, 7827, 7827, 7829, 7837, 7839, 7839,
    7841, 7841, 7843, 7843, 7845, 7845, 7847, 7847, 7849, 7849, 7851, 7851,
    7853, 7853, 7855, 7855, 7857, 7857, 7859, 7859, 7861, 7861, 7863, 7863,
    7865, 7865, 7867, 7867, 7869, 7869, 7871, 7871, 7873, 7873, 7875, 7875,
    7877, 7877, 7879, 7879, 7881, 7881, 7883, 7883, 7885, 7885, 7887, 7887,
    7889, 7889, 7891, 7891, 7893, 7893, 7895, 7895, 7897, 7897, 7899, 7899,
    7901, 7901, 7903, 7903, 7905, 7905, 7907, 7907, 7909, 7909, 7911, 7911,
    7913, 7913, 7915, 7915, 7917, 7917, 7919, 7919, 7921, 7921, 7923, 7923,
    7925, 7925, 7927, 7927, 7929, 7929, 7931, 7931, 7933, 7933, 7935, 7943,
    7952, 7957, 7968, 7975, 7984, 7991, 8000, 8005, 8016, 8023, 8032, 8039,
    8048, 8061, 8064, 8071, 8080, 8087, 8096, 8103, 8112, 8116, 8118, 8119,
    8126, 8126, 8130, 8132, 8134, 8135, 8144, 8147, 8150, 8151, 8160, 8167,
    8178, 8180, 8182, 8183, 8458, 8458, 8462, 8463, 8467, 8467, 8495, 8495,
    8500, 8500, 8505, 8505, 8508, 8509, 8518, 8521, 8526, 8526, 8580, 8580,
    11312, 11358, 11361, 11361, 11365, 11366, 11368, 11368, 11370, 11370, 11372,
    11372, 11377, 11377, 11379, 11380, 11382, 11387, 11393, 11393, 11395, 11395,
    11397, 11397, 11399, 11399, 11401, 11401, 11403, 11403, 11405, 11405, 11407,
    11407, 11409, 11409, 11411, 11411, 11413, 11413, 11415, 11415, 11417, 11417,
    11419, 11419, 11421, 11421, 11423, 11423, 11425, 11425, 11427, 11427, 11429,
    11429, 11431, 11431, 11433, 11433, 11435, 11435, 11437, 11437, 11439, 11439,
    11441, 11441, 11443, 11443, 11445, 11445, 11447, 11447, 11449, 11449, 11451,
    11451, 11453, 11453, 11455, 11455, 11457, 11457, 11459, 11459, 11461, 11461,
    11463, 11463, 11465, 11465, 11467, 11467, 11469, 11469, 11471, 11471, 11473,
    11473, 11475, 11475, 11477, 11477, 11479, 11479, 11481, 11481, 11483, 11483,
    11485, 11485, 11487, 11487, 11489, 11489, 11491, 11492, 11500, 11500, 11502,
    11502, 11507, 11507, 11520, 11557, 11559, 11559, 11565, 11565, 42561, 42561,
    42563, 42563, 42565, 42565, 42567, 42567, 42569, 42569, 42571, 42571, 42573,
    42573, 42575, 42575, 42577, 42577, 42579, 42579, 42581, 42581, 42583, 42583,
    42585, 42585, 42587, 42587, 42589, 42589, 42591, 42591, 42593, 42593, 42595,
    42595, 42597, 42597, 42599, 42599, 42601, 42601, 42603, 42603, 42605, 42605,
    42625, 42625, 42627, 42627, 42629, 42629, 42631, 42631, 42633, 42633, 42635,
    42635, 42637, 42637, 42639, 42639, 42641, 42641, 42643, 42643, 42645, 42645,
    42647, 42647, 42787, 42787, 42789, 42789, 42791, 42791, 42793, 42793, 42795,
    42795, 42797, 42797, 42799, 42801, 42803, 42803, 42805, 42805, 42807, 42807,
    42809, 42809, 42811, 42811, 42813, 42813, 42815, 42815, 42817, 42817, 42819,
    42819, 42821, 42821, 42823, 42823, 42825, 42825, 42827, 42827, 42829, 42829,
    42831, 42831, 42833, 42833, 42835, 42835, 42837, 42837, 42839, 42839, 42841,
    42841, 42843, 42843, 42845, 42845, 42847, 42847, 42849, 42849, 42851, 42851,
    42853, 42853, 42855, 42855, 42857, 42857, 42859, 42859, 42861, 42861, 42863,
    42863, 42865, 42872, 42874, 42874, 42876, 42876, 42879, 42879, 42881, 42881,
    42883, 42883, 42885, 42885, 42887, 42887, 42892, 42892, 42894, 42894, 42897,
    42897, 42899, 42899, 42913, 42913, 42915, 42915, 42917, 42917, 42919, 42919,
    42921, 42921, 43002, 43002, 64256, 64262, 64275, 64279, 65345, 65370, 51, 0,
    688, 705, 710, 721, 736, 740, 748, 748, 750, 750, 884, 884, 890, 890, 1369,
    1369, 1600, 1600, 1765, 1766, 2036, 2037, 2042, 2042, 2074, 2074, 2084,
    2084, 2088, 2088, 2417, 2417, 3654, 3654, 3782, 3782, 4348, 4348, 6103,
    6103, 6211, 6211, 6823, 6823, 7288, 7293, 7468, 7530, 7544, 7544, 7579,
    7615, 8305, 8305, 8319, 8319, 8336, 8348, 11388, 11389, 11631, 11631, 11823,
    11823, 12293, 12293, 12337, 12341, 12347, 12347, 12445, 12446, 12540, 12542,
    40981, 40981, 42232, 42237, 42508, 42508, 42623, 42623, 42775, 42783, 42864,
    42864, 42888, 42888, 43000, 43001, 43471, 43471, 43632, 43632, 43741, 43741,
    43763, 43764, 65392, 65392, 65438, 65439, 289, 0, 170, 170, 186, 186, 443,
    443, 448, 451, 660, 660, 1488, 1514, 1520, 1522, 1568, 1599, 1601, 1610,
    1646, 1647, 1649, 1747, 1749, 1749, 1774, 1775, 1786, 1788, 1791, 1791,
    1808, 1808, 1810, 1839, 1869, 1957, 1969, 1969, 1994, 2026, 2048, 2069,
    2112, 2136, 2208, 2208, 2210, 2220, 2308, 2361, 2365, 2365, 2384, 2384,
    2392, 2401, 2418, 2423, 2425, 2431, 2437, 2444, 2447, 2448, 2451, 2472,
    2474, 2480, 2482, 2482, 2486, 2489, 2493, 2493, 2510, 2510, 2524, 2525,
    2527, 2529, 2544, 2545, 2565, 2570, 2575, 2576, 2579, 2600, 2602, 2608,
    2610, 2611, 2613, 2614, 2616, 2617, 2649, 2652, 2654, 2654, 2674, 2676,
    2693, 2701, 2703, 2705, 2707, 2728, 2730, 2736, 2738, 2739, 2741, 2745,
    2749, 2749, 2768, 2768, 2784, 2785, 2821, 2828, 2831, 2832, 2835, 2856,
    2858, 2864, 2866, 2867, 2869, 2873, 2877, 2877, 2908, 2909, 2911, 2913,
    2929, 2929, 2947, 2947, 2949, 2954, 2958, 2960, 2962, 2965, 2969, 2970,
    2972, 2972, 2974, 2975, 2979, 2980, 2984, 2986, 2990, 3001, 3024, 3024,
    3077, 3084, 3086, 3088, 3090, 3112, 3114, 3123, 3125, 3129, 3133, 3133,
    3160, 3161, 3168, 3169, 3205, 3212, 3214, 3216, 3218, 3240, 3242, 3251,
    3253, 3257, 3261, 3261, 3294, 3294, 3296, 3297, 3313, 3314, 3333, 3340,
    3342, 3344, 3346, 3386, 3389, 3389, 3406, 3406, 3424, 3425, 3450, 3455,
    3461, 3478, 3482, 3505, 3507, 3515, 3517, 3517, 3520, 3526, 3585, 3632,
    3634, 3635, 3648, 3653, 3713, 3714, 3716, 3716, 3719, 3720, 3722, 3722,
    3725, 3725, 3732, 3735, 3737, 3743, 3745, 3747, 3749, 3749, 3751, 3751,
    3754, 3755, 3757, 3760, 3762, 3763, 3773, 3773, 3776, 3780, 3804, 3807,
    3840, 3840, 3904, 3911, 3913, 3948, 3976, 3980, 4096, 4138, 4159, 4159,
    4176, 4181, 4186, 4189, 4193, 4193, 4197, 4198, 4206, 4208, 4213, 4225,
    4238, 4238, 4304, 4346, 4349, 4680, 4682, 4685, 4688, 4694, 4696, 4696,
    4698, 4701, 4704, 4744, 4746, 4749, 4752, 4784, 4786, 4789, 4792, 4798,
    4800, 4800, 4802, 4805, 4808, 4822, 4824, 4880, 4882, 4885, 4888, 4954,
    4992, 5007, 5024, 5108, 5121, 5740, 5743, 5759, 5761, 5786, 5792, 5866,
    5888, 5900, 5902, 5905, 5920, 5937, 5952, 5969, 5984, 5996, 5998, 6000,
    6016, 6067, 6108, 6108, 6176, 6210, 6212, 6263, 6272, 6312, 6314, 6314,
    6320, 6389, 6400, 6428, 6480, 6509, 6512, 6516, 6528, 6571, 6593, 6599,
    6656, 6678, 6688, 6740, 6917, 6963, 6981, 6987, 7043, 7072, 7086, 7087,
    7098, 7141, 7168, 7203, 7245, 7247, 7258, 7287, 7401, 7404, 7406, 7409,
    7413, 7414, 8501, 8504, 11568, 11623, 11648, 11670, 11680, 11686, 11688,
    11694, 11696, 11702, 11704, 11710, 11712, 11718, 11720, 11726, 11728, 11734,
    11736, 11742, 12294, 12294, 12348, 12348, 12353, 12438, 12447, 12447, 12449,
    12538, 12543, 12543, 12549, 12589, 12593, 12686, 12704, 12730, 12784, 12799,
    13312, 13312, 19893, 19893, 19968, 19968, 40908, 40908, 40960, 40980, 40982,
    42124, 42192, 42231, 42240, 42507, 42512, 42527, 42538, 42539, 42606, 42606,
    42656, 42725, 43003, 43009, 43011, 43013, 43015, 43018, 43020, 43042, 43072,
    43123, 43138, 43187, 43250, 43255, 43259, 43259, 43274, 43301, 43312, 43334,
    43360, 43388, 43396, 43442, 43520, 43560, 43584, 43586, 43588, 43595, 43616,
    43631, 43633, 43638, 43642, 43642, 43648, 43695, 43697, 43697, 43701, 43702,
    43705, 43709, 43712, 43712, 43714, 43714, 43739, 43740, 43744, 43754, 43762,
    43762, 43777, 43782, 43785, 43790, 43793, 43798, 43808, 43814, 43816, 43822,
    43968, 44002, 44032, 44032, 55203, 55203, 55216, 55238, 55243, 55291, 63744,
    64109, 64112, 64217, 64285, 64285, 64287, 64296, 64298, 64310, 64312, 64316,
    64318, 64318, 64320, 64321, 64323, 64324, 64326, 64433, 64467, 64829, 64848,
    64911, 64914, 64967, 65008, 65019, 65136, 65140, 65142, 65276, 65382, 65391,
    65393, 65437, 65440, 65470, 65474, 65479, 65482, 65487, 65490, 65495, 65498,
    65500, 10, 0, 453, 453, 456, 456, 459, 459, 498, 498, 8072, 8079, 8088,
    8095, 8104, 8111, 8124, 8124, 8140, 8140, 8188, 8188, 576, 0, 65, 90, 192,
    214, 216, 222, 256, 256, 258, 258, 260, 260, 262, 262, 264, 264, 266, 266,
    268, 268, 270, 270, 272, 272, 274, 274, 276, 276, 278, 278, 280, 280, 282,
    282, 284, 284, 286, 286, 288, 288, 290, 290, 292, 292, 294, 294, 296, 296,
    298, 298, 300, 300, 302, 302, 304, 304, 306, 306, 308, 308, 310, 310, 313,
    313, 315, 315, 317, 317, 319, 319, 321, 321, 323, 323, 325, 325, 327, 327,
    330, 330, 332, 332, 334, 334, 336, 336, 338, 338, 340, 340, 342, 342, 344,
    344, 346, 346, 348, 348, 350, 350, 352, 352, 354, 354, 356, 356, 358, 358,
    360, 360, 362, 362, 364, 364, 366, 366, 368, 368, 370, 370, 372, 372, 374,
    374, 376, 377, 379, 379, 381, 381, 385, 386, 388, 388, 390, 391, 393, 395,
    398, 401, 403, 404, 406, 408, 412, 413, 415, 416, 418, 418, 420, 420, 422,
    423, 425, 425, 428, 428, 430, 431, 433, 435, 437, 437, 439, 440, 444, 444,
    452, 452, 455, 455, 458, 458, 461, 461, 463, 463, 465, 465, 467, 467, 469,
    469, 471, 471, 473, 473, 475, 475, 478, 478, 480, 480, 482, 482, 484, 484,
    486, 486, 488, 488, 490, 490, 492, 492, 494, 494, 497, 497, 500, 500, 502,
    504, 506, 506, 508, 508, 510, 510, 512, 512, 514, 514, 516, 516, 518, 518,
    520, 520, 522, 522, 524, 524, 526, 526, 528, 528, 530, 530, 532, 532, 534,
    534, 536, 536, 538, 538, 540, 540, 542, 542, 544, 544, 546, 546, 548, 548,
    550, 550, 552, 552, 554, 554, 556, 556, 558, 558, 560, 560, 562, 562, 570,
    571, 573, 574, 577, 577, 579, 582, 584, 584, 586, 586, 588, 588, 590, 590,
    880, 880, 882, 882, 886, 886, 902, 902, 904, 906, 908, 908, 910, 911, 913,
    929, 931, 939, 975, 975, 978, 980, 984, 984, 986, 986, 988, 988, 990, 990,
    992, 992, 994, 994, 996, 996, 998, 998, 1000, 1000, 1002, 1002, 1004, 1004,
    1006, 1006, 1012, 1012, 1015, 1015, 1017, 1018, 1021, 1071, 1120, 1120,
    1122, 1122, 1124, 1124, 1126, 1126, 1128, 1128, 1130, 1130, 1132, 1132,
    1134, 1134, 1136, 1136, 1138, 1138, 1140, 1140, 1142, 1142, 1144, 1144,
    1146, 1146, 1148, 1148, 1150, 1150, 1152, 1152, 1162, 1162, 1164, 1164,
    1166, 1166, 1168, 1168, 1170, 1170, 1172, 1172, 1174, 1174, 1176, 1176,
    1178, 1178, 1180, 1180, 1182, 1182, 1184, 1184, 1186, 1186, 1188, 1188,
    1190, 1190, 1192, 1192, 1194, 1194, 1196, 1196, 1198, 1198, 1200, 1200,
    1202, 1202, 1204, 1204, 1206, 1206, 1208, 1208, 1210, 1210, 1212, 1212,
    1214, 1214, 1216, 1217, 1219, 1219, 1221, 1221, 1223, 1223, 1225, 1225,
    1227, 1227, 1229, 1229, 1232, 1232, 1234, 1234, 1236, 1236, 1238, 1238,
    1240, 1240, 1242, 1242, 1244, 1244, 1246, 1246, 1248, 1248, 1250, 1250,
    1252, 1252, 1254, 1254, 1256, 1256, 1258, 1258, 1260, 1260, 1262, 1262,
    1264, 1264, 1266, 1266, 1268, 1268, 1270, 1270, 1272, 1272, 1274, 1274,
    1276, 1276, 1278, 1278, 1280, 1280, 1282, 1282, 1284, 1284, 1286, 1286,
    1288, 1288, 1290, 1290, 1292, 1292, 1294, 1294, 1296, 1296, 1298, 1298,
    1300, 1300, 1302, 1302, 1304, 1304, 1306, 1306, 1308, 1308, 1310, 1310,
    1312, 1312, 1314, 1314, 1316, 1316, 1318, 1318, 1329, 1366, 4256, 4293,
    4295, 4295, 4301, 4301, 7680, 7680, 7682, 7682, 7684, 7684, 7686, 7686,
    7688, 7688, 7690, 7690, 7692, 7692, 7694, 7694, 7696, 7696, 7698, 7698,
    7700, 7700, 7702, 7702, 7704, 7704, 7706, 7706, 7708, 7708, 7710, 7710,
    7712, 7712, 7714, 7714, 7716, 7716, 7718, 7718, 7720, 7720, 7722, 7722,
    7724, 7724, 7726, 7726, 7728, 7728, 7730, 7730, 7732, 7732, 7734, 7734,
    7736, 7736, 7738, 7738, 7740, 7740, 7742, 7742, 7744, 7744, 7746, 7746,
    7748, 7748, 7750, 7750, 7752, 7752, 7754, 7754, 7756, 7756, 7758, 7758,
    7760, 7760, 7762, 7762, 7764, 7764, 7766, 7766, 7768, 7768, 7770, 7770,
    7772, 7772, 7774, 7774, 7776, 7776, 7778, 7778, 7780, 7780, 7782, 7782,
    7784, 7784, 7786, 7786, 7788, 7788, 7790, 7790, 7792, 7792, 7794, 7794,
    7796, 7796, 7798, 7798, 7800, 7800, 7802, 7802, 7804, 7804, 7806, 7806,
    7808, 7808, 7810, 7810, 7812, 7812, 7814, 7814, 7816, 7816, 7818, 7818,
    7820, 7820, 7822, 7822, 7824, 7824, 7826, 7826, 7828, 7828, 7838, 7838,
    7840, 7840, 7842, 7842, 7844, 7844, 7846, 7846, 7848, 7848, 7850, 7850,
    7852, 7852, 7854, 7854, 7856, 7856, 7858, 7858, 7860, 7860, 7862, 7862,
    7864, 7864, 7866, 7866, 7868, 7868, 7870, 7870, 7872, 7872, 7874, 7874,
    7876, 7876, 7878, 7878, 7880, 7880, 7882, 7882, 7884, 7884, 7886, 7886,
    7888, 7888, 7890, 7890, 7892, 7892, 7894, 7894, 7896, 7896, 7898, 7898,
    7900, 7900, 7902, 7902, 7904, 7904, 7906, 7906, 7908, 7908, 7910, 7910,
    7912, 7912, 7914, 7914, 7916, 7916, 7918, 7918, 7920, 7920, 7922, 7922,
    7924, 7924, 7926, 7926, 7928, 7928, 7930, 7930, 7932, 7932, 7934, 7934,
    7944, 7951, 7960, 7965, 7976, 7983, 7992, 7999, 8008, 8013, 8025, 8025,
    8027, 8027, 8029, 8029, 8031, 8031, 8040, 8047, 8120, 8123, 8136, 8139,
    8152, 8155, 8168, 8172, 8184, 8187, 8450, 8450, 8455, 8455, 8459, 8461,
    8464, 8466, 8469, 8469, 8473, 8477, 8484, 8484, 8486, 8486, 8488, 8488,
    8490, 8493, 8496, 8499, 8510, 8511, 8517, 8517, 8579, 8579, 11264, 11310,
    11360, 11360, 11362, 11364, 11367, 11367, 11369, 11369, 11371, 11371, 11373,
    11376, 11378, 11378, 11381, 11381, 11390, 11392, 11394, 11394, 11396, 11396,
    11398, 11398, 11400, 11400, 11402, 11402, 11404, 11404, 11406, 11406, 11408,
    11408, 11410, 11410, 11412, 11412, 11414, 11414, 11416, 11416, 11418, 11418,
    11420, 11420, 11422, 11422, 11424, 11424, 11426, 11426, 11428, 11428, 11430,
    11430, 11432, 11432, 11434, 11434, 11436, 11436, 11438, 11438, 11440, 11440,
    11442, 11442, 11444, 11444, 11446, 11446, 11448, 11448, 11450, 11450, 11452,
    11452, 11454, 11454, 11456, 11456, 11458, 11458, 11460, 11460, 11462, 11462,
    11464, 11464, 11466, 11466, 11468, 11468, 11470, 11470, 11472, 11472, 11474,
    11474, 11476, 11476, 11478, 11478, 11480, 11480, 11482, 11482, 11484, 11484,
    11486, 11486, 11488, 11488, 11490, 11490, 11499, 11499, 11501, 11501, 11506,
    11506, 42560, 42560, 42562, 42562, 42564, 42564, 42566, 42566, 42568, 42568,
    42570, 42570, 42572, 42572, 42574, 42574, 42576, 42576, 42578, 42578, 42580,
    42580, 42582, 42582, 42584, 42584, 42586, 42586, 42588, 42588, 42590, 42590,
    42592, 42592, 42594, 42594, 42596, 42596, 42598, 42598, 42600, 42600, 42602,
    42602, 42604, 42604, 42624, 42624, 42626, 42626, 42628, 42628, 42630, 42630,
    42632, 42632, 42634, 42634, 42636, 42636, 42638, 42638, 42640, 42640, 42642,
    42642, 42644, 42644, 42646, 42646, 42786, 42786, 42788, 42788, 42790, 42790,
    42792, 42792, 42794, 42794, 42796, 42796, 42798, 42798, 42802, 42802, 42804,
    42804, 42806, 42806, 42808, 42808, 42810, 42810, 42812, 42812, 42814, 42814,
    42816, 42816, 42818, 42818, 42820, 42820, 42822, 42822, 42824, 42824, 42826,
    42826, 42828, 42828, 42830, 42830, 42832, 42832, 42834, 42834, 42836, 42836,
    42838, 42838, 42840, 42840, 42842, 42842, 42844, 42844, 42846, 42846, 42848,
    42848, 42850, 42850, 42852, 42852, 42854, 42854, 42856, 42856, 42858, 42858,
    42860, 42860, 42862, 42862, 42873, 42873, 42875, 42875, 42877, 42878, 42880,
    42880, 42882, 42882, 42884, 42884, 42886, 42886, 42891, 42891, 42893, 42893,
    42896, 42896, 42898, 42898, 42912, 42912, 42914, 42914, 42916, 42916, 42918,
    42918, 42920, 42920, 42922, 42922, 65313, 65338, 35, 0, 48, 57, 1632, 1641,
    1776, 1785, 1984, 1993, 2406, 2415, 2534, 2543, 2662, 2671, 2790, 2799,
    2918, 2927, 3046, 3055, 3174, 3183, 3302, 3311, 3430, 3439, 3664, 3673,
    3792, 3801, 3872, 3881, 4160, 4169, 4240, 4249, 6112, 6121, 6160, 6169,
    6470, 6479, 6608, 6617, 6784, 6793, 6800, 6809, 6992, 7001, 7088, 7097,
    7232, 7241, 7248, 7257, 42528, 42537, 43216, 43225, 43264, 43273, 43472,
    43481, 43600, 43609, 44016, 44025, 65296, 65305, 7, 0, 5870, 5872, 8544,
    8578, 8581, 8584, 12295, 12295, 12321, 12329, 12344, 12346, 42726, 42735, 3,
    0, 34, 34, 36, 36, 92, 92, 3, 0, 36, 36, 39, 39, 92, 92, 754, 0, 10, 1, 0,
    0, 0, 0, 12, 1, 0, 0, 0, 0, 14, 1, 0, 0, 0, 0, 16, 1, 0, 0, 0, 0, 18, 1, 0,
    0, 0, 0, 20, 1, 0, 0, 0, 0, 22, 1, 0, 0, 0, 0, 24, 1, 0, 0, 0, 0, 26, 1, 0,
    0, 0, 0, 28, 1, 0, 0, 0, 0, 30, 1, 0, 0, 0, 0, 32, 1, 0, 0, 0, 0, 34, 1, 0,
    0, 0, 0, 36, 1, 0, 0, 0, 0, 38, 1, 0, 0, 0, 0, 40, 1, 0, 0, 0, 0, 42, 1, 0,
    0, 0, 0, 44, 1, 0, 0, 0, 0, 46, 1, 0, 0, 0, 0, 48, 1, 0, 0, 0, 0, 50, 1, 0,
    0, 0, 0, 52, 1, 0, 0, 0, 0, 54, 1, 0, 0, 0, 0, 56, 1, 0, 0, 0, 0, 58, 1, 0,
    0, 0, 0, 60, 1, 0, 0, 0, 0, 62, 1, 0, 0, 0, 0, 64, 1, 0, 0, 0, 0, 66, 1, 0,
    0, 0, 0, 68, 1, 0, 0, 0, 0, 70, 1, 0, 0, 0, 0, 72, 1, 0, 0, 0, 0, 74, 1, 0,
    0, 0, 0, 76, 1, 0, 0, 0, 0, 78, 1, 0, 0, 0, 0, 80, 1, 0, 0, 0, 0, 82, 1, 0,
    0, 0, 0, 84, 1, 0, 0, 0, 0, 86, 1, 0, 0, 0, 0, 88, 1, 0, 0, 0, 0, 90, 1, 0,
    0, 0, 0, 92, 1, 0, 0, 0, 0, 94, 1, 0, 0, 0, 0, 96, 1, 0, 0, 0, 0, 98, 1, 0,
    0, 0, 0, 100, 1, 0, 0, 0, 0, 102, 1, 0, 0, 0, 0, 104, 1, 0, 0, 0, 0, 106, 1,
    0, 0, 0, 0, 108, 1, 0, 0, 0, 0, 110, 1, 0, 0, 0, 0, 112, 1, 0, 0, 0, 0, 114,
    1, 0, 0, 0, 0, 116, 1, 0, 0, 0, 0, 118, 1, 0, 0, 0, 0, 120, 1, 0, 0, 0, 0,
    122, 1, 0, 0, 0, 0, 124, 1, 0, 0, 0, 0, 126, 1, 0, 0, 0, 0, 128, 1, 0, 0, 0,
    0, 130, 1, 0, 0, 0, 0, 132, 1, 0, 0, 0, 0, 134, 1, 0, 0, 0, 0, 136, 1, 0, 0,
    0, 0, 138, 1, 0, 0, 0, 0, 154, 1, 0, 0, 0, 0, 156, 1, 0, 0, 0, 0, 158, 1, 0,
    0, 0, 0, 160, 1, 0, 0, 0, 0, 162, 1, 0, 0, 0, 0, 164, 1, 0, 0, 0, 0, 166, 1,
    0, 0, 0, 0, 170, 1, 0, 0, 0, 0, 172, 1, 0, 0, 0, 0, 180, 1, 0, 0, 0, 0, 182,
    1, 0, 0, 0, 0, 184, 1, 0, 0, 0, 0, 186, 1, 0, 0, 0, 0, 188, 1, 0, 0, 0, 0,
    190, 1, 0, 0, 0, 0, 192, 1, 0, 0, 0, 0, 194, 1, 0, 0, 0, 0, 196, 1, 0, 0, 0,
    0, 198, 1, 0, 0, 0, 0, 226, 1, 0, 0, 0, 1, 200, 1, 0, 0, 0, 1, 202, 1, 0, 0,
    0, 1, 204, 1, 0, 0, 0, 1, 206, 1, 0, 0, 0, 2, 208, 1, 0, 0, 0, 2, 210, 1, 0,
    0, 0, 2, 212, 1, 0, 0, 0, 2, 214, 1, 0, 0, 0, 3, 216, 1, 0, 0, 0, 3, 218, 1,
    0, 0, 0, 3, 220, 1, 0, 0, 0, 3, 222, 1, 0, 0, 0, 3, 224, 1, 0, 0, 0, 4, 228,
    1, 0, 0, 0, 6, 235, 1, 0, 0, 0, 8, 245, 1, 0, 0, 0, 10, 256, 1, 0, 0, 0, 12,
    262, 1, 0, 0, 0, 14, 272, 1, 0, 0, 0, 16, 276, 1, 0, 0, 0, 18, 290, 1, 0, 0,
    0, 20, 294, 1, 0, 0, 0, 22, 296, 1, 0, 0, 0, 24, 298, 1, 0, 0, 0, 26, 300,
    1, 0, 0, 0, 28, 302, 1, 0, 0, 0, 30, 304, 1, 0, 0, 0, 32, 306, 1, 0, 0, 0,
    34, 310, 1, 0, 0, 0, 36, 313, 1, 0, 0, 0, 38, 315, 1, 0, 0, 0, 40, 317, 1,
    0, 0, 0, 42, 319, 1, 0, 0, 0, 44, 321, 1, 0, 0, 0, 46, 323, 1, 0, 0, 0, 48,
    327, 1, 0, 0, 0, 50, 330, 1, 0, 0, 0, 52, 333, 1, 0, 0, 0, 54, 337, 1, 0, 0,
    0, 56, 349, 1, 0, 0, 0, 58, 351, 1, 0, 0, 0, 60, 353, 1, 0, 0, 0, 62, 356,
    1, 0, 0, 0, 64, 358, 1, 0, 0, 0, 66, 360, 1, 0, 0, 0, 68, 362, 1, 0, 0, 0,
    70, 364, 1, 0, 0, 0, 72, 366, 1, 0, 0, 0, 74, 369, 1, 0, 0, 0, 76, 372, 1,
    0, 0, 0, 78, 375, 1, 0, 0, 0, 80, 378, 1, 0, 0, 0, 82, 381, 1, 0, 0, 0, 84,
    383, 1, 0, 0, 0, 86, 386, 1, 0, 0, 0, 88, 388, 1, 0, 0, 0, 90, 390, 1, 0, 0,
    0, 92, 393, 1, 0, 0, 0, 94, 396, 1, 0, 0, 0, 96, 399, 1, 0, 0, 0, 98, 401,
    1, 0, 0, 0, 100, 403, 1, 0, 0, 0, 102, 405, 1, 0, 0, 0, 104, 409, 1, 0, 0,
    0, 106, 413, 1, 0, 0, 0, 108, 417, 1, 0, 0, 0, 110, 424, 1, 0, 0, 0, 112,
    431, 1, 0, 0, 0, 114, 435, 1, 0, 0, 0, 116, 441, 1, 0, 0, 0, 118, 444, 1, 0,
    0, 0, 120, 449, 1, 0, 0, 0, 122, 454, 1, 0, 0, 0, 124, 459, 1, 0, 0, 0, 126,
    462, 1, 0, 0, 0, 128, 465, 1, 0, 0, 0, 130, 468, 1, 0, 0, 0, 132, 472, 1, 0,
    0, 0, 134, 476, 1, 0, 0, 0, 136, 482, 1, 0, 0, 0, 138, 488, 1, 0, 0, 0, 140,
    493, 1, 0, 0, 0, 142, 495, 1, 0, 0, 0, 144, 499, 1, 0, 0, 0, 146, 501, 1, 0,
    0, 0, 148, 507, 1, 0, 0, 0, 150, 512, 1, 0, 0, 0, 152, 526, 1, 0, 0, 0, 154,
    529, 1, 0, 0, 0, 156, 544, 1, 0, 0, 0, 158, 548, 1, 0, 0, 0, 160, 561, 1, 0,
    0, 0, 162, 574, 1, 0, 0, 0, 164, 576, 1, 0, 0, 0, 166, 586, 1, 0, 0, 0, 168,
    593, 1, 0, 0, 0, 170, 614, 1, 0, 0, 0, 172, 619, 1, 0, 0, 0, 174, 621, 1, 0,
    0, 0, 176, 624, 1, 0, 0, 0, 178, 633, 1, 0, 0, 0, 180, 635, 1, 0, 0, 0, 182,
    639, 1, 0, 0, 0, 184, 643, 1, 0, 0, 0, 186, 649, 1, 0, 0, 0, 188, 651, 1, 0,
    0, 0, 190, 653, 1, 0, 0, 0, 192, 655, 1, 0, 0, 0, 194, 657, 1, 0, 0, 0, 196,
    659, 1, 0, 0, 0, 198, 661, 1, 0, 0, 0, 200, 663, 1, 0, 0, 0, 202, 673, 1, 0,
    0, 0, 204, 675, 1, 0, 0, 0, 206, 677, 1, 0, 0, 0, 208, 682, 1, 0, 0, 0, 210,
    692, 1, 0, 0, 0, 212, 694, 1, 0, 0, 0, 214, 696, 1, 0, 0, 0, 216, 702, 1, 0,
    0, 0, 218, 711, 1, 0, 0, 0, 220, 721, 1, 0, 0, 0, 222, 723, 1, 0, 0, 0, 224,
    725, 1, 0, 0, 0, 226, 730, 1, 0, 0, 0, 228, 229, 5, 167, 0, 0, 229, 230, 5,
    66, 0, 0, 230, 231, 5, 76, 0, 0, 231, 232, 5, 79, 0, 0, 232, 233, 5, 67, 0,
    0, 233, 234, 5, 75, 0, 0, 234, 5, 1, 0, 0, 0, 235, 236, 5, 167, 0, 0, 236,
    237, 5, 86, 0, 0, 237, 238, 5, 65, 0, 0, 238, 239, 5, 82, 0, 0, 239, 240, 5,
    73, 0, 0, 240, 241, 5, 65, 0, 0, 241, 242, 5, 66, 0, 0, 242, 243, 5, 76, 0,
    0, 243, 244, 5, 69, 0, 0, 244, 7, 1, 0, 0, 0, 245, 249, 5, 167, 0, 0, 246,
    248, 8, 0, 0, 0, 247, 246, 1, 0, 0, 0, 248, 251, 1, 0, 0, 0, 249, 250, 1, 0,
    0, 0, 249, 247, 1, 0, 0, 0, 250, 252, 1, 0, 0, 0, 251, 249, 1, 0, 0, 0, 252,
    253, 5, 167, 0, 0, 253, 9, 1, 0, 0, 0, 254, 257, 3, 4, 0, 0, 255, 257, 3, 6,
    1, 0, 256, 254, 1, 0, 0, 0, 256, 255, 1, 0, 0, 0, 257, 258, 1, 0, 0, 0, 258,
    259, 3, 8, 2, 0, 259, 260, 1, 0, 0, 0, 260, 261, 6, 3, 0, 0, 261, 11, 1, 0,
    0, 0, 262, 263, 5, 167, 0, 0, 263, 264, 5, 47, 0, 0, 264, 265, 5, 66, 0, 0,
    265, 266, 5, 76, 0, 0, 266, 267, 5, 79, 0, 0, 267, 268, 5, 67, 0, 0, 268,
    269, 5, 75, 0, 0, 269, 270, 1, 0, 0, 0, 270, 271, 6, 4, 0, 0, 271, 13, 1, 0,
    0, 0, 272, 273, 7, 1, 0, 0, 273, 274, 1, 0, 0, 0, 274, 275, 6, 5, 1, 0, 275,
    15, 1, 0, 0, 0, 276, 277, 5, 47, 0, 0, 277, 278, 5, 42, 0, 0, 278, 282, 1,
    0, 0, 0, 279, 281, 9, 0, 0, 0, 280, 279, 1, 0, 0, 0, 281, 284, 1, 0, 0, 0,
    282, 283, 1, 0, 0, 0, 282, 280, 1, 0, 0, 0, 283, 285, 1, 0, 0, 0, 284, 282,
    1, 0, 0, 0, 285, 286, 5, 42, 0, 0, 286, 287, 5, 47, 0, 0, 287, 288, 1, 0, 0,
    0, 288, 289, 6, 6, 2, 0, 289, 17, 1, 0, 0, 0, 290, 291, 7, 2, 0, 0, 291,
    292, 1, 0, 0, 0, 292, 293, 6, 7, 3, 0, 293, 19, 1, 0, 0, 0, 294, 295, 5, 46,
    0, 0, 295, 21, 1, 0, 0, 0, 296, 297, 5, 44, 0, 0, 297, 23, 1, 0, 0, 0, 298,
    299, 5, 40, 0, 0, 299, 25, 1, 0, 0, 0, 300, 301, 5, 41, 0, 0, 301, 27, 1, 0,
    0, 0, 302, 303, 5, 91, 0, 0, 303, 29, 1, 0, 0, 0, 304, 305, 5, 93, 0, 0,
    305, 31, 1, 0, 0, 0, 306, 307, 5, 123, 0, 0, 307, 308, 1, 0, 0, 0, 308, 309,
    6, 14, 4, 0, 309, 33, 1, 0, 0, 0, 310, 311, 5, 125, 0, 0, 311, 312, 6, 15,
    5, 0, 312, 35, 1, 0, 0, 0, 313, 314, 5, 42, 0, 0, 314, 37, 1, 0, 0, 0, 315,
    316, 5, 94, 0, 0, 316, 39, 1, 0, 0, 0, 317, 318, 5, 47, 0, 0, 318, 41, 1, 0,
    0, 0, 319, 320, 5, 43, 0, 0, 320, 43, 1, 0, 0, 0, 321, 322, 5, 45, 0, 0,
    322, 45, 1, 0, 0, 0, 323, 324, 5, 120, 0, 0, 324, 325, 5, 111, 0, 0, 325,
    326, 5, 114, 0, 0, 326, 47, 1, 0, 0, 0, 327, 328, 5, 43, 0, 0, 328, 329, 5,
    43, 0, 0, 329, 49, 1, 0, 0, 0, 330, 331, 5, 45, 0, 0, 331, 332, 5, 45, 0, 0,
    332, 51, 1, 0, 0, 0, 333, 334, 5, 97, 0, 0, 334, 335, 5, 110, 0, 0, 335,
    336, 5, 100, 0, 0, 336, 53, 1, 0, 0, 0, 337, 338, 5, 110, 0, 0, 338, 339, 5,
    111, 0, 0, 339, 340, 5, 116, 0, 0, 340, 55, 1, 0, 0, 0, 341, 342, 5, 164, 0,
    0, 342, 350, 5, 164, 0, 0, 343, 344, 5, 163, 0, 0, 344, 350, 5, 163, 0, 0,
    345, 346, 5, 36, 0, 0, 346, 350, 5, 36, 0, 0, 347, 348, 5, 8364, 0, 0, 348,
    350, 5, 8364, 0, 0, 349, 341, 1, 0, 0, 0, 349, 343, 1, 0, 0, 0, 349, 345, 1,
    0, 0, 0, 349, 347, 1, 0, 0, 0, 350, 57, 1, 0, 0, 0, 351, 352, 7, 3, 0, 0,
    352, 59, 1, 0, 0, 0, 353, 354, 5, 111, 0, 0, 354, 355, 5, 114, 0, 0, 355,
    61, 1, 0, 0, 0, 356, 357, 5, 37, 0, 0, 357, 63, 1, 0, 0, 0, 358, 359, 5, 33,
    0, 0, 359, 65, 1, 0, 0, 0, 360, 361, 5, 58, 0, 0, 361, 67, 1, 0, 0, 0, 362,
    363, 5, 59, 0, 0, 363, 69, 1, 0, 0, 0, 364, 365, 5, 61, 0, 0, 365, 71, 1, 0,
    0, 0, 366, 367, 5, 45, 0, 0, 367, 368, 5, 62, 0, 0, 368, 73, 1, 0, 0, 0,
    369, 370, 5, 61, 0, 0, 370, 371, 5, 62, 0, 0, 371, 75, 1, 0, 0, 0, 372, 373,
    5, 46, 0, 0, 373, 374, 5, 46, 0, 0, 374, 77, 1, 0, 0, 0, 375, 376, 5, 58, 0,
    0, 376, 377, 5, 58, 0, 0, 377, 79, 1, 0, 0, 0, 378, 379, 5, 59, 0, 0, 379,
    380, 5, 59, 0, 0, 380, 81, 1, 0, 0, 0, 381, 382, 5, 63, 0, 0, 382, 83, 1, 0,
    0, 0, 383, 384, 5, 63, 0, 0, 384, 385, 5, 58, 0, 0, 385, 85, 1, 0, 0, 0,
    386, 387, 5, 60, 0, 0, 387, 87, 1, 0, 0, 0, 388, 389, 5, 62, 0, 0, 389, 89,
    1, 0, 0, 0, 390, 391, 5, 60, 0, 0, 391, 392, 5, 61, 0, 0, 392, 91, 1, 0, 0,
    0, 393, 394, 5, 62, 0, 0, 394, 395, 5, 61, 0, 0, 395, 93, 1, 0, 0, 0, 396,
    397, 5, 33, 0, 0, 397, 398, 5, 61, 0, 0, 398, 95, 1, 0, 0, 0, 399, 400, 5,
    64, 0, 0, 400, 97, 1, 0, 0, 0, 401, 402, 5, 95, 0, 0, 402, 99, 1, 0, 0, 0,
    403, 404, 5, 35, 0, 0, 404, 101, 1, 0, 0, 0, 405, 406, 5, 109, 0, 0, 406,
    407, 5, 97, 0, 0, 407, 408, 5, 112, 0, 0, 408, 103, 1, 0, 0, 0, 409, 410, 5,
    102, 0, 0, 410, 411, 5, 117, 0, 0, 411, 412, 5, 110, 0, 0, 412, 105, 1, 0,
    0, 0, 413, 414, 5, 108, 0, 0, 414, 415, 5, 101, 0, 0, 415, 416, 5, 116, 0,
    0, 416, 107, 1, 0, 0, 0, 417, 418, 5, 105, 0, 0, 418, 419, 5, 109, 0, 0,
    419, 420, 5, 112, 0, 0, 420, 421, 5, 111, 0, 0, 421, 422, 5, 114, 0, 0, 422,
    423, 5, 116, 0, 0, 423, 109, 1, 0, 0, 0, 424, 425, 5, 97, 0, 0, 425, 426, 5,
    115, 0, 0, 426, 427, 5, 115, 0, 0, 427, 428, 5, 101, 0, 0, 428, 429, 5, 114,
    0, 0, 429, 430, 5, 116, 0, 0, 430, 111, 1, 0, 0, 0, 431, 432, 5, 118, 0, 0,
    432, 433, 5, 97, 0, 0, 433, 434, 5, 114, 0, 0, 434, 113, 1, 0, 0, 0, 435,
    436, 5, 119, 0, 0, 436, 437, 5, 104, 0, 0, 437, 438, 5, 101, 0, 0, 438, 439,
    5, 114, 0, 0, 439, 440, 5, 101, 0, 0, 440, 115, 1, 0, 0, 0, 441, 442, 5,
    105, 0, 0, 442, 443, 5, 102, 0, 0, 443, 117, 1, 0, 0, 0, 444, 445, 5, 116,
    0, 0, 445, 446, 5, 104, 0, 0, 446, 447, 5, 101, 0, 0, 447, 448, 5, 110, 0,
    0, 448, 119, 1, 0, 0, 0, 449, 450, 5, 101, 0, 0, 450, 451, 5, 108, 0, 0,
    451, 452, 5, 115, 0, 0, 452, 453, 5, 101, 0, 0, 453, 121, 1, 0, 0, 0, 454,
    455, 5, 119, 0, 0, 455, 456, 5, 104, 0, 0, 456, 457, 5, 101, 0, 0, 457, 458,
    5, 110, 0, 0, 458, 123, 1, 0, 0, 0, 459, 460, 5, 97, 0, 0, 460, 461, 5, 115,
    0, 0, 461, 125, 1, 0, 0, 0, 462, 463, 5, 105, 0, 0, 463, 464, 5, 115, 0, 0,
    464, 127, 1, 0, 0, 0, 465, 466, 5, 105, 0, 0, 466, 467, 5, 110, 0, 0, 467,
    129, 1, 0, 0, 0, 468, 469, 5, 111, 0, 0, 469, 470, 5, 117, 0, 0, 470, 471,
    5, 116, 0, 0, 471, 131, 1, 0, 0, 0, 472, 473, 5, 117, 0, 0, 473, 474, 5,
    115, 0, 0, 474, 475, 5, 101, 0, 0, 475, 133, 1, 0, 0, 0, 476, 477, 5, 105,
    0, 0, 477, 478, 5, 115, 0, 0, 478, 479, 5, 110, 0, 0, 479, 480, 5, 111, 0,
    0, 480, 481, 5, 116, 0, 0, 481, 135, 1, 0, 0, 0, 482, 483, 5, 110, 0, 0,
    483, 484, 5, 111, 0, 0, 484, 485, 5, 116, 0, 0, 485, 486, 5, 105, 0, 0, 486,
    487, 5, 110, 0, 0, 487, 137, 1, 0, 0, 0, 488, 489, 5, 105, 0, 0, 489, 490,
    5, 115, 0, 0, 490, 491, 5, 105, 0, 0, 491, 492, 5, 110, 0, 0, 492, 139, 1,
    0, 0, 0, 493, 494, 2, 48, 57, 0, 494, 141, 1, 0, 0, 0, 495, 496, 2, 49, 57,
    0, 496, 143, 1, 0, 0, 0, 497, 500, 3, 140, 68, 0, 498, 500, 7, 4, 0, 0, 499,
    497, 1, 0, 0, 0, 499, 498, 1, 0, 0, 0, 500, 145, 1, 0, 0, 0, 501, 502, 3,
    140, 68, 0, 502, 503, 3, 140, 68, 0, 503, 504, 3, 140, 68, 0, 504, 505, 3,
    140, 68, 0, 505, 147, 1, 0, 0, 0, 506, 508, 3, 140, 68, 0, 507, 506, 1, 0,
    0, 0, 507, 508, 1, 0, 0, 0, 508, 509, 1, 0, 0, 0, 509, 510, 3, 140, 68, 0,
    510, 149, 1, 0, 0, 0, 511, 513, 3, 140, 68, 0, 512, 511, 1, 0, 0, 0, 512,
    513, 1, 0, 0, 0, 513, 514, 1, 0, 0, 0, 514, 515, 3, 140, 68, 0, 515, 151, 1,
    0, 0, 0, 516, 520, 3, 140, 68, 0, 517, 519, 3, 144, 70, 0, 518, 517, 1, 0,
    0, 0, 519, 522, 1, 0, 0, 0, 520, 518, 1, 0, 0, 0, 520, 521, 1, 0, 0, 0, 521,
    523, 1, 0, 0, 0, 522, 520, 1, 0, 0, 0, 523, 524, 3, 140, 68, 0, 524, 527, 1,
    0, 0, 0, 525, 527, 3, 140, 68, 0, 526, 516, 1, 0, 0, 0, 526, 525, 1, 0, 0,
    0, 527, 153, 1, 0, 0, 0, 528, 530, 3, 152, 74, 0, 529, 528, 1, 0, 0, 0, 529,
    530, 1, 0, 0, 0, 530, 531, 1, 0, 0, 0, 531, 532, 5, 46, 0, 0, 532, 533, 3,
    152, 74, 0, 533, 155, 1, 0, 0, 0, 534, 538, 3, 142, 69, 0, 535, 537, 3, 144,
    70, 0, 536, 535, 1, 0, 0, 0, 537, 540, 1, 0, 0, 0, 538, 536, 1, 0, 0, 0,
    538, 539, 1, 0, 0, 0, 539, 541, 1, 0, 0, 0, 540, 538, 1, 0, 0, 0, 541, 542,
    3, 140, 68, 0, 542, 545, 1, 0, 0, 0, 543, 545, 3, 140, 68, 0, 544, 534, 1,
    0, 0, 0, 544, 543, 1, 0, 0, 0, 545, 157, 1, 0, 0, 0, 546, 549, 3, 154, 75,
    0, 547, 549, 3, 156, 76, 0, 548, 546, 1, 0, 0, 0, 548, 547, 1, 0, 0, 0, 549,
    550, 1, 0, 0, 0, 550, 551, 3, 56, 26, 0, 551, 159, 1, 0, 0, 0, 552, 554, 3,
    152, 74, 0, 553, 552, 1, 0, 0, 0, 553, 554, 1, 0, 0, 0, 554, 555, 1, 0, 0,
    0, 555, 557, 5, 46, 0, 0, 556, 558, 3, 140, 68, 0, 557, 556, 1, 0, 0, 0,
    557, 558, 1, 0, 0, 0, 558, 559, 1, 0, 0, 0, 559, 562, 3, 140, 68, 0, 560,
    562, 3, 156, 76, 0, 561, 553, 1, 0, 0, 0, 561, 560, 1, 0, 0, 0, 562, 563, 1,
    0, 0, 0, 563, 564, 3, 58, 27, 0, 564, 161, 1, 0, 0, 0, 565, 566, 5, 116, 0,
    0, 566, 567, 5, 114, 0, 0, 567, 568, 5, 117, 0, 0, 568, 575, 5, 101, 0, 0,
    569, 570, 5, 102, 0, 0, 570, 571, 5, 97, 0, 0, 571, 572, 5, 108, 0, 0, 572,
    573, 5, 115, 0, 0, 573, 575, 5, 101, 0, 0, 574, 565, 1, 0, 0, 0, 574, 569,
    1, 0, 0, 0, 575, 163, 1, 0, 0, 0, 576, 577, 5, 117, 0, 0, 577, 578, 5, 110,
    0, 0, 578, 579, 5, 100, 0, 0, 579, 580, 5, 101, 0, 0, 580, 581, 5, 102, 0,
    0, 581, 582, 5, 105, 0, 0, 582, 583, 5, 110, 0, 0, 583, 584, 5, 101, 0, 0,
    584, 585, 5, 100, 0, 0, 585, 165, 1, 0, 0, 0, 586, 587, 3, 96, 46, 0, 587,
    588, 3, 146, 71, 0, 588, 589, 3, 44, 20, 0, 589, 590, 3, 148, 72, 0, 590,
    591, 3, 44, 20, 0, 591, 592, 3, 150, 73, 0, 592, 167, 1, 0, 0, 0, 593, 594,
    3, 196, 96, 0, 594, 169, 1, 0, 0, 0, 595, 598, 3, 178, 87, 0, 596, 598, 3,
    98, 47, 0, 597, 595, 1, 0, 0, 0, 597, 596, 1, 0, 0, 0, 598, 604, 1, 0, 0, 0,
    599, 603, 3, 178, 87, 0, 600, 603, 3, 98, 47, 0, 601, 603, 3, 168, 82, 0,
    602, 599, 1, 0, 0, 0, 602, 600, 1, 0, 0, 0, 602, 601, 1, 0, 0, 0, 603, 606,
    1, 0, 0, 0, 604, 602, 1, 0, 0, 0, 604, 605, 1, 0, 0, 0, 605, 615, 1, 0, 0,
    0, 606, 604, 1, 0, 0, 0, 607, 609, 5, 96, 0, 0, 608, 610, 8, 5, 0, 0, 609,
    608, 1, 0, 0, 0, 610, 611, 1, 0, 0, 0, 611, 609, 1, 0, 0, 0, 611, 612, 1, 0,
    0, 0, 612, 613, 1, 0, 0, 0, 613, 615, 5, 96, 0, 0, 614, 597, 1, 0, 0, 0,
    614, 607, 1, 0, 0, 0, 615, 171, 1, 0, 0, 0, 616, 620, 3, 170, 83, 0, 617,
    620, 3, 114, 55, 0, 618, 620, 3, 102, 49, 0, 619, 616, 1, 0, 0, 0, 619, 617,
    1, 0, 0, 0, 619, 618, 1, 0, 0, 0, 620, 173, 1, 0, 0, 0, 621, 622, 5, 92, 0,
    0, 622, 623, 7, 6, 0, 0, 623, 175, 1, 0, 0, 0, 624, 625, 5, 92, 0, 0, 625,
    626, 7, 7, 0, 0, 626, 177, 1, 0, 0, 0, 627, 634, 3, 186, 91, 0, 628, 634, 3,
    188, 92, 0, 629, 634, 3, 190, 93, 0, 630, 634, 3, 192, 94, 0, 631, 634, 3,
    194, 95, 0, 632, 634, 3, 198, 97, 0, 633, 627, 1, 0, 0, 0, 633, 628, 1, 0,
    0, 0, 633, 629, 1, 0, 0, 0, 633, 630, 1, 0, 0, 0, 633, 631, 1, 0, 0, 0, 633,
    632, 1, 0, 0, 0, 634, 179, 1, 0, 0, 0, 635, 636, 5, 39, 0, 0, 636, 637, 1,
    0, 0, 0, 637, 638, 6, 88, 6, 0, 638, 181, 1, 0, 0, 0, 639, 640, 5, 34, 0, 0,
    640, 641, 1, 0, 0, 0, 641, 642, 6, 89, 7, 0, 642, 183, 1, 0, 0, 0, 643, 644,
    5, 34, 0, 0, 644, 645, 5, 34, 0, 0, 645, 646, 5, 34, 0, 0, 646, 647, 1, 0,
    0, 0, 647, 648, 6, 90, 8, 0, 648, 185, 1, 0, 0, 0, 649, 650, 7, 8, 0, 0,
    650, 187, 1, 0, 0, 0, 651, 652, 7, 9, 0, 0, 652, 189, 1, 0, 0, 0, 653, 654,
    7, 10, 0, 0, 654, 191, 1, 0, 0, 0, 655, 656, 7, 11, 0, 0, 656, 193, 1, 0, 0,
    0, 657, 658, 7, 12, 0, 0, 658, 195, 1, 0, 0, 0, 659, 660, 7, 13, 0, 0, 660,
    197, 1, 0, 0, 0, 661, 662, 7, 14, 0, 0, 662, 199, 1, 0, 0, 0, 663, 664, 5,
    34, 0, 0, 664, 665, 1, 0, 0, 0, 665, 666, 6, 98, 9, 0, 666, 201, 1, 0, 0, 0,
    667, 669, 8, 15, 0, 0, 668, 667, 1, 0, 0, 0, 669, 670, 1, 0, 0, 0, 670, 668,
    1, 0, 0, 0, 670, 671, 1, 0, 0, 0, 671, 674, 1, 0, 0, 0, 672, 674, 5, 36, 0,
    0, 673, 668, 1, 0, 0, 0, 673, 672, 1, 0, 0, 0, 674, 203, 1, 0, 0, 0, 675,
    676, 3, 174, 85, 0, 676, 205, 1, 0, 0, 0, 677, 678, 5, 36, 0, 0, 678, 679,
    5, 123, 0, 0, 679, 680, 1, 0, 0, 0, 680, 681, 6, 101, 4, 0, 681, 207, 1, 0,
    0, 0, 682, 683, 5, 39, 0, 0, 683, 684, 1, 0, 0, 0, 684, 685, 6, 102, 9, 0,
    685, 209, 1, 0, 0, 0, 686, 688, 8, 16, 0, 0, 687, 686, 1, 0, 0, 0, 688, 689,
    1, 0, 0, 0, 689, 687, 1, 0, 0, 0, 689, 690, 1, 0, 0, 0, 690, 693, 1, 0, 0,
    0, 691, 693, 5, 36, 0, 0, 692, 687, 1, 0, 0, 0, 692, 691, 1, 0, 0, 0, 693,
    211, 1, 0, 0, 0, 694, 695, 3, 174, 85, 0, 695, 213, 1, 0, 0, 0, 696, 697, 5,
    36, 0, 0, 697, 698, 5, 123, 0, 0, 698, 699, 1, 0, 0, 0, 699, 700, 6, 105, 4,
    0, 700, 215, 1, 0, 0, 0, 701, 703, 3, 218, 107, 0, 702, 701, 1, 0, 0, 0,
    702, 703, 1, 0, 0, 0, 703, 704, 1, 0, 0, 0, 704, 705, 5, 34, 0, 0, 705, 706,
    5, 34, 0, 0, 706, 707, 5, 34, 0, 0, 707, 708, 1, 0, 0, 0, 708, 709, 6, 106,
    9, 0, 709, 217, 1, 0, 0, 0, 710, 712, 5, 34, 0, 0, 711, 710, 1, 0, 0, 0,
    712, 713, 1, 0, 0, 0, 713, 711, 1, 0, 0, 0, 713, 714, 1, 0, 0, 0, 714, 219,
    1, 0, 0, 0, 715, 717, 8, 15, 0, 0, 716, 715, 1, 0, 0, 0, 717, 718, 1, 0, 0,
    0, 718, 716, 1, 0, 0, 0, 718, 719, 1, 0, 0, 0, 719, 722, 1, 0, 0, 0, 720,
    722, 5, 36, 0, 0, 721, 716, 1, 0, 0, 0, 721, 720, 1, 0, 0, 0, 722, 221, 1,
    0, 0, 0, 723, 724, 3, 176, 86, 0, 724, 223, 1, 0, 0, 0, 725, 726, 5, 36, 0,
    0, 726, 727, 5, 123, 0, 0, 727, 728, 1, 0, 0, 0, 728, 729, 6, 110, 4, 0,
    729, 225, 1, 0, 0, 0, 730, 731, 9, 0, 0, 0, 731, 227, 1, 0, 0, 0, 36, 0, 1,
    2, 3, 249, 256, 282, 349, 499, 507, 512, 520, 526, 529, 538, 544, 548, 553,
    557, 561, 574, 597, 602, 604, 611, 614, 619, 633, 670, 673, 689, 692, 702,
    713, 718, 721, 10, 0, 3, 0, 0, 4, 0, 0, 5, 0, 6, 0, 0, 5, 0, 0, 1, 15, 0, 5,
    2, 0, 5, 1, 0, 5, 3, 0, 4, 0, 0,
  ]

  private static __ATN: ATN
  public static get _ATN(): ATN {
    if (!FPlusLexer.__ATN) {
      FPlusLexer.__ATN = new ATNDeserializer().deserialize(
        FPlusLexer._serializedATN,
      )
    }

    return FPlusLexer.__ATN
  }

  static DecisionsToDFA = FPlusLexer._ATN.decisionToState.map(
    (ds: DecisionState, index: number) => new DFA(ds, index),
  )
}
